import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { CHART_COLORS } from "./palette";

export interface BarChartVerticalDatum {
  label: string;
  value: number;
}

interface BarChartVerticalProps {
  data: BarChartVerticalDatum[];
  /** Cor da barra (default brand-500). */
  barColor?: string;
  /** Format do valor no tooltip e eixo Y. */
  valueFormatter?: (value: number) => string;
}

/**
 * Bar chart vertical (labels no eixo X, valor no Y). Adequado para
 * series temporais densas (custo por dia) com 7-90 buckets.
 */
export function BarChartVertical({
  data,
  barColor = CHART_COLORS.brand,
  valueFormatter = (v) => String(v),
}: BarChartVerticalProps) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{ top: 8, right: 12, left: 4, bottom: 4 }}
      >
        <CartesianGrid stroke={CHART_COLORS.line} vertical={false} />
        <XAxis
          dataKey="label"
          stroke={CHART_COLORS.ink500}
          tick={{ fontSize: 11 }}
          tickLine={false}
          axisLine={{ stroke: CHART_COLORS.line }}
        />
        <YAxis
          stroke={CHART_COLORS.ink500}
          tick={{ fontSize: 11 }}
          tickLine={false}
          axisLine={false}
          width={48}
          tickFormatter={valueFormatter}
        />
        <Tooltip
          cursor={{ fill: CHART_COLORS.line, opacity: 0.4 }}
          contentStyle={{
            borderRadius: 12,
            border: `1px solid ${CHART_COLORS.line}`,
            background: "#fff",
            fontSize: 12,
            boxShadow: "0 6px 16px rgba(15, 14, 29, 0.08)",
          }}
          labelStyle={{ color: CHART_COLORS.ink700, fontWeight: 600 }}
          formatter={(value) => [valueFormatter(Number(value ?? 0))]}
        />
        <Bar
          dataKey="value"
          fill={barColor}
          radius={[6, 6, 0, 0]}
          maxBarSize={48}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
